import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
// import withStyles from "@material-ui/core/styles/withStyles";
import "./styles.css";
import "animate.css/animate.css";
// import VIrus from "../../images/VIrus.svg"
const EvaluatorModal = ({
  classes,
  open,
  setIsOpen
}) => {
  return (
    <Modal open={open}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh", justifyContent: "center" }}
      >
        <Grid className="evaluatorModalContainer">
          <Typography className="evalDesc" style={{ fontSize: 24 }} dangerouslySetInnerHTML={{ __html: "Don't forget to select the area on the chart." }}>
          </Typography>
          <Grid container style={{ justifyContent: "center" }}>
            <Button className="submitButton" onClick={() => setIsOpen(false)}>
              OK
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default EvaluatorModal;
